<h2 mat-dialog-title>Invio a {{userData.username}}</h2>

<mat-dialog-content class="mat-typography">
    <div>
        <form [formGroup]="form" *ngIf="form">
            <mat-form-field appearance="fill">
                <mat-label>Oggetto</mat-label>
                <input type="string" matInput formControlName="subject">
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>Messaggio</mat-label>
                <textarea matInput formControlName="content"></textarea>
            </mat-form-field>
        </form>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="pt-5 pb-4">
    <button mat-button (click)="sendEmail()" [disabled]="form.invalid">Invia</button>
    <button mat-button mat-dialog-close>Chiudi</button>
</mat-dialog-actions>